// extracted by mini-css-extract-plugin
export default {"label":"labels_label__H3amb"};